<template>
  <div>
    <div class="ty-wrapper">
      <div class="ty-container">
        <div class="ty-header"><i class="fas fa-lock"></i> Secure Checkout</div>
        <div class="ty-inner">
          <div class="ty-inner-left">
            <h1><i class="fas fa-check-circle"></i> Thank your for your order</h1>
            <h2>Your Order Number is {{ sale_id }}.</h2>
            <p>We sincerely thank you for choosing Authorize Local.
               With this order, we want to assure you of the same satisfaction that
               all Authorize Local customers have come to enjoy. If you have any questions,
               then please don't hesitate to call us at <a href="tel:+1-212-335-0233">+1-212-335-0233</a> or e-mail us at <a href="mailto:sales@authorizelocal.com">sales@authorizelocal.com</a></p>
          </div>
          <div class="ty-inner-right">
            <h3>What happens next?</h3>
            <ul class="ty-what-happens-list">
              <li>A summary of your order was just e-mailed to you</li>
              <li>Your first receipt was just e-mailed to you</li>
              <li>We will contact you shortly to get to know your business</li>
            </ul>
            <div class="sales-rep">
              <img src="../../../../assets/images/salesmanager.png" />
              <p>Your Authorize Local representative is now personally inspecting your order and will contact you shortly.</p>
            </div>
          </div>
        </div>
        <div class="ty-bottom">
          <div class="bottom-links">
            <div>
            <i class="fas fa-user-circle"></i>
            </div>
            <div>
              <h2>Complete Your Account</h2>
            <p>Your Authorize Local account automatically created upon checkout. All you have to do now is to set a password for your account.</p>
            </div>
            <div>
              <a :href="`https://${mail}`" target="_blank">
                <div class="al-button">Check Your Email</div>
              </a>
            </div>
          </div>
          <div class="bottom-links">
  <div>
            <i class="fas fa-search-location"></i>
            </div>
            <div>
              <h2>Explore More</h2>
            <p>Discover what Authorize Local can do and how it can elevate your company. Discover additional services and campaigns that might work for you.</p>
            </div>
            <a  href="https://authlorizelocal.com">
              <div class="al-button">Explore More</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    mail: {
      type: String
    },
    sale_id: {
      type: String
    }
  }
}
</script>
<style lang="scss">
.ty-wrapper {
  min-height: calc(100vh - 216px);
  display:flex;
  align-items:center;
  justify-content: center;
}
.ty-container{
  width:1000px;
  height:max-content;
  border:1px solid #ccc;
  border-radius:7px;
}
.ty-header {
  background-color:#1d2346;
  color:#fff;
  padding:10px;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}
.ty-inner{
  display:flex;
  flex-wrap:wrap;
  padding:20px;
}
.ty-inner-left, .ty-inner-right{
  width:50%;
}
.ty-inner-left{
  padding:10px;
  h1{
    color:#8bc451;
    font-weight: 400;
    margin-bottom:20px;
  }
  h2 {
    font-size:16px;
    margin-bottom:20px;
  }
  p {
    font-size:12px;
    font-weight: 500;
    hyphens: none;
    a{
      color:#f08028;
    }
  }
}
.ty-inner-right{
  background-color:#f5f5f5;
  font-size:12px;
  padding:10px;
  h3{
    font-size:14px;
    margin-bottom:20px;
  }
  .ty-what-happens-list{
    padding-bottom:20px;
    border-bottom:1px solid #ccc;
    li{
      padding-left:20px;
      position:relative;
      margin-bottom:10px;
      &:after{
      font-family: "Font Awesome 5 Free";
      content: '\f00C';
      font-weight: 900;
      font-size: 14px;
      margin-right: 10px;
      color: #8bc451;
      position: absolute;
      top: -1px;
      left: 0px
      }
    }
  }
}
.sales-rep{
  display:flex;
  align-items: center;
  padding:10px;
  p{
    padding-left:15px;
  }
}
.bottom-links{
  background-color:#f2f2f2;
  padding:20px;
  display:flex;
  justify-content: flex-start;
  align-content: center;
  border-top:1px solid #ccc;
  div{
    padding:10px;
  }
  i {
    font-size:42px;
    color:#1d2346;
  }
  h2{
    font-size:16px;
  }
  p{
    font-size:12px;
  }
  .al-button{
    width:max-content;
    font-size:14px;
    font-weight: 500;
  }
}
@media (max-width:999px){
  .ty-container{
    width: 100%;
  }
  .ty-inner{
    flex-direction: column;
  }
  .ty-inner-left, .ty-inner-right{
    width: 100%;
  }
  .bottom-links {
    flex-direction: column;
  }
}
</style>
